import { render, staticRenderFns } from "./B2cInvoice.vue?vue&type=template&id=7a6913b1&scoped=true&"
import script from "./B2cInvoice.vue?vue&type=script&lang=js&"
export * from "./B2cInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6913b1",
  null
  
)

export default component.exports